import { render, staticRenderFns } from "./UcInvoiceReferences.yaml?vue&type=template&id=7c2a743e&component"
import script from "./UcInvoiceReferences.yaml?vue&type=script&lang=ts&component"
export * from "./UcInvoiceReferences.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports